import React, { useState, useEffect } from 'react';
import './Hablamos.css';
import axios from 'axios';
import imagenContenido from "../assets/precios_y_tiempos_img_contenido_digital.jpeg";
import { Helmet } from "react-helmet";

const Hablamos = () => {

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const [formData, setFormData] = useState({
    nombre: '',
    apellidos: '',
    email: '',
    ciudad: '',
    indicativo: '',
    telefono: '',
    celular: '',
    pais: '',
    universidad: '',
    cargo: '',
    mensaje: ''
  });

  const paises = [
    "Colombia", "Alemania", "Argentina", "Australia", "Austria", "Bélgica",
    "Bolivia", "Brasil", "Canadá", "Chile", "China", "Corea del Sur",
    "Costa Rica", "Cuba", "Dinamarca", "Ecuador", "Egipto", "El Salvador",
    "Emiratos Árabes Unidos", "España", "Estados Unidos", "Filipinas", "Finlandia",
    "Francia", "Grecia", "Guatemala", "Honduras", "Hungría", "India", "Indonesia",
    "Irlanda", "Israel", "Italia", "Japón", "Malasia", "Marruecos", "México",
    "Nicaragua", "Noruega", "Nueva Zelanda", "Países Bajos", "Panamá", "Paraguay",
    "Perú", "Polonia", "Portugal", "Puerto Rico", "Reino Unido", "República Checa",
    "República Dominicana", "Rusia", "Suecia", "Suiza", "Uruguay", "Venezuela"
  ];

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(formData.email)) {
        alert("Por favor, ingresa un correo electrónico válido.");
        return;
      }
      const dataWithDate = {
        Fecha: new Date().toLocaleDateString('es-CO'),
        ...formData
      };

      await axios.post(
        'https://server-coral-omega.vercel.app/api/sendForm',
        dataWithDate,
        { headers: { "Content-Type": "application/json" } }
      );

      alert('¡Datos enviados correctamente!');
      setFormData({
        nombre: '',
        apellidos: '',
        email: '',
        ciudad: '',
        indicativo: '',
        telefono: '',
        celular: '',
        pais: '',
        universidad: '',
        cargo: '',
        mensaje: ''
      });
    } catch (error) {
      console.error('Error al enviar los datos:', error);
      alert('Hubo un error al enviar el formulario.');
    }
  };

  const texto = (
    <div className="form-text">
      <h4>¡Hola! Soy la Directora de Innovación Educativa y Estrategia Digital en EduIALogic, y me encantará conocer tu necesidad. Contactarme es muy fácil. Puedes elegir la opción que más te acomode:</h4>
      <br />
      <h4>📞 1. Llama directo a mi celular:</h4>
      <p>
        <a href="tel:+573133853521" style={{ color: '#204C8E', textDecoration: 'underline' }}>
          +57 313 385 35 21
        </a>
      </p>
      <p>Tu llamada es prioridad. Si no contesto de inmediato, te devuelvo la llamada lo antes posible.</p>
      <br />
      <h4>💬 2. Escríbeme por WhatsApp:</h4>
      <p>
        Usa el mismo número (
        <a
          href="https://wa.me/573133853521"
          target="_blank"
          rel="noopener noreferrer"
          style={{ color: '#204C8E', textDecoration: 'underline' }}
        >
          +57 313 385 3521
        </a>
        ) y cuéntame brevemente en qué puedo ayudarte. Te responderé personalmente.
      </p>
      <br />
      <h4>📩 3. Envíame un correo electrónico:</h4>
      <p>
        A{' '}
        <a
          href="mailto:contacto@eduialogic.com"
          style={{ color: '#204C8E', textDecoration: 'underline' }}
        >
          contacto@eduialogic.com
        </a>
        , contándome en pocas líneas tu requerimiento. Te responderé con una propuesta clara de cómo podemos apoyarte.
      </p>
      <br />
      <h4>📝 4. Llena el formulario que ves al lado:</h4>
      <p>Y te contactaré a la mayor brevedad posible.</p>
    </div>
  );


  const formulario = (
    <form className="formulario-demo" onSubmit={handleSubmit}>
      <div className="form-row">
        <input type="text" name="nombre" placeholder="Nombre*" value={formData.nombre} onChange={handleChange} required />
        <input type="text" name="apellidos" placeholder="Apellidos*" value={formData.apellidos} onChange={handleChange} required />
      </div>
      <input type="email" name="email" placeholder="Email*" value={formData.email} onChange={handleChange} required />
      <input type="text" name="ciudad" placeholder="Ciudad*" value={formData.ciudad} onChange={handleChange} required />
      <div className="form-row">
        <input type="text" name="indicativo" placeholder="Indicativo (opcional)" value={formData.indicativo} onChange={handleChange} />
        <input type="tel" name="telefono" placeholder="Teléfono fijo (opcional)" value={formData.telefono} onChange={handleChange} />
      </div>
      <input type="tel" name="celular" placeholder="Celular*" value={formData.celular} onChange={handleChange} required />
      <select name="pais" value={formData.pais} onChange={handleChange} required>
        <option value="" disabled>País*</option>
        {paises.map((pais) => (
          <option key={pais} value={pais}>{pais}</option>
        ))}
      </select>
      <input type="text" name="universidad" placeholder="Nombre de la institución educativa*" value={formData.universidad} onChange={handleChange} required />
      <select name="cargo" value={formData.cargo} onChange={handleChange} required>
        <option value="" disabled>Cargo en tu institución educativa*</option>
        <option>Rector</option>
        <option>Docente</option>
        <option>Otro</option>
      </select>
      <textarea name="mensaje" placeholder="Mensaje (opcional, máx. 300 caracteres)" maxLength="300" value={formData.mensaje} onChange={handleChange} />
      
       {/* Aquí agrego la frase con el enlace */}
        <p style={{ fontSize: "0.9rem", marginTop: "1rem" }}>
          He leído y acepto la{" "}
          <a
            href="https://gamma.app/docs/Politica-de-Privacidad-fahles7foihk7sz?mode=doc"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "#204C8E", textDecoration: "underline" }}
          >

            política de privacidad
          </a>
          .
        </p>
      
      <button type="submit">Enviar</button>
    </form>
  );


  const imagen = (
    <div className="image-container">
      <img src={imagenContenido} alt="Precios y tiempos" />
    </div>
  );

  return (
    <>
      <Helmet>
        <title>EduIALogic | eduialogic | Eduialogic | Transformamos la educación digital en Colombia</title>
        <meta
          name="description"
          content="Virtualizamos contenidos educativos con pedagogía de calidad, tecnología ágil y producción de bajo costo para todos los niveles de formación."
        />
        <link rel="canonical" href="https://www.eduialogic.com/" />
      </Helmet>

      <section id="contacto" className="contacto-container">
        <div className="form-section">
          {isMobile ? (
            <>
              {texto}
              {formulario}
              {imagen}
            </>
          ) : (
            <>
              <div className="form-row-desktop">
                {texto}
                {formulario}
              </div>
              {imagen}
            </>
          )}
        </div>
      </section>

    </>
  );
};

export default Hablamos;